import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const loc = useLocation();

  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <div className="text-slate-400 text-sm font-mono">Loading platform…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Field officers only have access to the /field mobile shell — bounce
  // them out of any admin-console routes they might land on.
  const shells = { field_officer: "/field", station_staff: "/station" };
  const inShell = (p) => loc.pathname === p || loc.pathname.startsWith(p + "/");
  const mine = shells[user?.role];
  if (mine && !inShell(mine)) return <Navigate to={mine} replace />;
  if (!mine && Object.values(shells).some(inShell)) return <Navigate to="/dashboard" replace />;

  return children;
}
